import {RouteRecordRaw} from "vue-router";
import StartSeasonPage from "@/modules/season/pages/StartSeasonPage.vue";
import Evaluation from "@/modules/season/pages/Evaluation.vue";

export const routes: RouteRecordRaw[] = [
  {
    path: '/evaluation',
    name: 'evaluation',
    component: Evaluation,
  },
  {
    path: '/season/start',
    name: 'season.start',
    component: StartSeasonPage,
  },
];